import { IdDescription } from 'tms-lib';

// Where a funnel file has got to (Pongees points, Oct 2026). Mirrors the Status* values in
// TMSWeb.Common.Constants.FunnelConstants - the API sends these and the Status filter matches on
// them, so the two must stay in step.
export enum FunnelFileStatuses {
  sent = 'Sent',
  pending = 'Pending',
  failed = 'Failed',
}

// A status as a person reads it. A function, not a constant array, so $localize runs after the
// language resolver has loaded the translations.
export function funnelFileStatusName(status: string | undefined | null): string {
  switch (status) {
    case FunnelFileStatuses.sent:
      return $localize`Sent`;
    case FunnelFileStatuses.pending:
      return $localize`Pending`;
    case FunnelFileStatuses.failed:
      return $localize`Failed`;
    default:
      // Anything unrecognised shows as sent rather than vanishing.
      return status ?? '';
  }
}

// The Status filter's options.
export function funnelFileStatusOptions(): IdDescription[] {
  return Object.values(FunnelFileStatuses).map((id) => ({ id, description: funnelFileStatusName(id) }));
}

// The badge colour for a status in the Funnel Files grid (gridService.badge). Bootstrap's text-bg-*
// pairs each background with a readable text colour; 'text-dark' would turn light in Dark mode
// (_theme.scss), leaving Pending as light text on yellow.
export function funnelFileStatusBadgeClass(status: string | undefined | null): string {
  switch (status) {
    case FunnelFileStatuses.sent:
      return 'text-bg-success';
    case FunnelFileStatuses.pending:
      return 'text-bg-warning';
    case FunnelFileStatuses.failed:
      return 'text-bg-danger';
    default:
      return 'text-bg-secondary';
  }
}
